import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ControlErrorsComponent } from '@components/admin/configurator/forms/control-errors/control-errors.component';
import { FormsModule } from '@angular/forms';
import { ErrorDisplayMode } from '@models/interfaces/configuration/DynamicForm.interface';
import { BaseControl } from '../base-control';

@Component({
  selector: 'app-text-form-control',
  standalone: true,
  imports: [CommonModule, FormsModule, ControlErrorsComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './text-form-control.component.html',
  styleUrl: './text-form-control.component.css'
})
export class TextFormControlComponent extends BaseControl<string> {
  @Input() id: string = '';
  @Input() label: string = '';
  @Input() placeholder: string = '';
  @Input() disabled: boolean = false;
  @Input() type: 'text' | 'email' | 'password' | 'url' = 'text';
  @Input() override errorDisplayMode: ErrorDisplayMode | undefined = ErrorDisplayMode.Always;
  
  public canShow1passSuggestion() {
    return this.type === 'password' || this.type === 'email';
  }
}